module.exports = __webpack_public_path__ + "static/img/wq-2.71141ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/wq-2.png
// module id = +k5c
// module chunks = 0